import Pagination from './BlazePagination';

export default Pagination;
